module.exports = __webpack_public_path__ + "static/media/banner_s_01.1d5f4e3e.jpg";